import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LocalLoaderService } from '../../shared/local-loader/local-loader.service';

/**
 * Attach this token to any HTTP request to opt-in to local loading state.
 * The value is a string key that matches the `key` input on `<app-local-loader>`.
 *
 * @example
 * this.http.get(url, {
 *   context: new HttpContext().set(LOCAL_LOADER_KEY, 'delay-distribution'),
 * });
 */
export const LOCAL_LOADER_KEY = new HttpContextToken<string | null>(() => null);

export const localLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const key = req.context.get(LOCAL_LOADER_KEY);
  if (!key) return next(req);

  const loaderService = inject(LocalLoaderService);
  loaderService.show(key);

  return next(req).pipe(finalize(() => loaderService.hide(key)));
};
